import styled from "styled-components";
import Button from "@mui/material/Button";
import { defaultValueGet, defaultValuePathGet } from "common/parameters_common";
import InputField from "components/UI/InputField";
import ItemTags from "components/common/tag/ItemTags";
import { TAG_RESOURCE_TYPE } from "constant/search/tag_search";
import {
  INPUT_TYPE_TEXT,
  INPUT_TYPE_TEXT_FIELD,
} from "constant/topic/topic.const";

type TopicFormProps = {
  control: any;
  handleSubmit: Function;
  onSubmit: Function;
  reset: Function;
  defaultValues?: any;
  onTagsChange?: Function;
  isInputWayText?: boolean;
};

const TopicForm = ({
  onSubmit,
  handleSubmit,
  reset,
  defaultValues,
  control,
  onTagsChange,
  isInputWayText,
}: TopicFormProps) => {
  const nameDefault = defaultValueGet(defaultValues, "name", "");
  const descriptionDefault = defaultValueGet(defaultValues, "description", "");
  const tagsDefault = defaultValueGet(defaultValues, "tags", []);
  const optionalFieldsDefault = defaultValueGet(
    defaultValues,
    "optionalFields",
    {}
  );
  const textContentDefault = defaultValuePathGet(
    optionalFieldsDefault,
    [INPUT_TYPE_TEXT, INPUT_TYPE_TEXT_FIELD.CONTENT],
    ""
  );
  const textTranslationDefault = defaultValuePathGet(
    optionalFieldsDefault,
    [INPUT_TYPE_TEXT, INPUT_TYPE_TEXT_FIELD.TRANSLATION],
    ""
  );

  return (
    <DivForm>
      <form>
        <DivField>
          <InputField
            name="name"
            control={control}
            label="name"
            defaultValue={nameDefault}
          />
        </DivField>

        <DivField>
          <InputField
            name="description"
            control={control}
            label="description"
            defaultValue={descriptionDefault}
          />
        </DivField>

        {isInputWayText && (
          <>
            <DivTextContentField>
              <InputField
                name="textContent"
                control={control}
                label="text content"
                defaultValue={textContentDefault}
                type="area"
                multiline
                rows={4}
              />
            </DivTextContentField>

            <DivTextContentField>
              <InputField
                name="textTranslation"
                control={control}
                label="text translation"
                defaultValue={textTranslationDefault}
                type="area"
                multiline
                rows={4}
              />
            </DivTextContentField>
          </>
        )}

        <DivField>
          <ItemTags
            resourceType={TAG_RESOURCE_TYPE.TOPIC}
            tagsDefault={tagsDefault}
            onTagsChange={onTagsChange}
          />
        </DivField>

        <DivNav>
          <Button onClick={handleSubmit(onSubmit)} type="submit">
            Submit
          </Button>
          <Button onClick={() => reset()} variant={"outlined"}>
            Reset
          </Button>
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
`;

const DivTextContentField = styled.div`
  margin-top: 1rem;
  width: 50%;
  div {
    width: 100%;
  }
`;

const DivNav = styled.div`
  margin-top: 2rem;
`;

export default TopicForm;
